import React from "react";
import { Link } from "react-router-dom";
import JsonData from "../data/data.json";
import { Contact } from "./contact";

export const NotFound = () => {
  return (
    <div id="notfound">
      <div className="container">
        <div className="section-title impressum text-center">
          <h1>Seite nicht gefunden</h1>
          <p>
            Die aufgerufene Seite existiert nicht oder wurde verschoben.
          </p>
          <Link to="/" className="btn btn-custom btn-lg">
            Zur Startseite
          </Link>
        </div>
      </div>
      <Contact data={JsonData.Contact} />
    </div>
  );
};
